module.exports = __webpack_public_path__ + "static/media/Cash_In.3d7cbd60.svg";